import { makeStyles } from "@material-ui/core";

export const formStyles = makeStyles(theme => ({
  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    padding: theme.spacing(2, 0)
  },
  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1)
  },
  fieldLabel: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
    color: "#424242",
    marginBottom: theme.spacing(0.5)
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px"
    }
  },
  chip: {
    height: "56px",
    width: "fit-content",
    minWidth: "120px",
    background: "#F5F8F3",
    border: "2px solid #E5ECD1",
    borderRadius: "8px",
    fontFamily: "Roboto",
    fontWeight: 500,
    fontSize: "1rem",
    color: "#424242",
    padding: theme.spacing(0, 2)
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(2)
  },
  button: {
    height: "48px",
    minWidth: "120px",
    borderRadius: "8px",
    fontWeight: 600,
    textTransform: "none",
    fontSize: "1rem",
    [theme.breakpoints.down("xs")]: {
      width: "100%"
    }
  },
  // Estilos antigos mantidos para compatibilidade (caso sejam usados em outro lugar)
  boxAlign: {
    marginTop: "1.3rem",
    background: "none",
    display: "flex",
    textAlign: "center",
    border: "none",
    alignItems: "center"
  },
  genericLabel: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "0.9rem",
    lineHeight: "1.35rem",
    color: "#757575"
  },
  error: {
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "0.9rem",
    lineHeight: "1.35rem",
    color: "#FF0000",
    marginLeft: "0.5rem"
  },
  inputWithRadius: {
    border: "2px solid #E5ECD1",
    borderRadius: "1.68"
  },
  fiscalNoteText: {
    margin: "0 0.8rem",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "1.1rem",
    color: "#3EA0DE"
  },
  boxItemPopover: {
    width: "10rem",
    height: "3rem",
    textAlign: "center",
    padding: "0.5rem",
    "&:hover": {
      cursor: "pointer",
      background: "#F4F4F4"
    }
  },
  listItemText: {
    fontSize: "1.1rem",
    fontFamily: "Roboto",
    fontWeight: 500,
    lineHeight: "0.9rem"
  },
  label: {
    fontFamily: "Inter",
    fontWeight: 550,
    fontSize: "0.9rem",
    lineHeight: "1.35rem",
    color: "#757575",
    marginBottom: "1rem",
    [theme.breakpoints.between(0, 500)]: {
      fontSize: "0.8rem"
    }
  },
  bigInput: {
    width: "100%",
    [theme.breakpoints.between(0, 800)]: {
      width: "80%"
    }
  }
}));
